import { squaresApi } from '../../../api';
import type { SquareStateSetter } from '../types';
import { buildGrid } from '../utils';

export const createFetchSquares = (set: SquareStateSetter) => {
  return async (boardId: string): Promise<void> => {
    set({ isLoading: true, error: null, boardId });
    try {
      const squares = await squaresApi.getAll(boardId);
      set({
        squares,
        grid: buildGrid(squares),
        isLoading: false,
      });
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : 'Failed to fetch squares',
        isLoading: false,
      });
    }
  };
};
